import React, { useState } from "react";
import { connect } from 'react-redux'
import { signOut } from '../../store/actions/authActions'
import { useTranslation } from 'react-i18next';
import { AlertOkCancelComponent } from '../AlertsComponents/AlertsComponent'
import LoaderView from '../SpinnerLoader/LoaderView';
import LanguageSelectorComponent from "../LanguageSelectorComponent";

const SignedInLinks = (props) => {
    const { t } = useTranslation();
    const [showingAlert, setShowAlert] = useState(false)
    const [isLoading, setIsLoading] = useState(false)

    function signOutAlert() {
        setShowAlert(true);
    }


    function signOut() {
        props.signOut();
    }

    return (
        <span>

            {showingAlert ?
                < AlertOkCancelComponent title={t("Logout") + "?"} subtitle={t("SureLogout?")} closeAlert={(confirm) => {

                    if (confirm) {
                        // do the code
                        console.log("user confirm");
                        setShowAlert(false);
                        setIsLoading(true);
                        signOut()
                        // signout;
                    }
                    else {
                        setShowAlert(false);
                    }

                }} />
                : null}

            {isLoading ?
                <LoaderView text={t("SigningOut") + "..."} />
                : null}

            <ul className="right " >

                {/* <li>
                    <NavLink to="/create">Add/Edit Card</NavLink>
                </li> */}

                <li style={{ height: 60 }}><button className="hide-on-med-and-down" onClick={signOutAlert} style={{ background: 'none', border: 'none', color: 'inherit', cursor: 'pointer', padding: 0 }}> {t("Logout")}</button></li>

                {/* <li style={{ height: 60 }}>
                    <NavLink to={{
                        pathname: '/dashboard',
                        state: {
                            fromInside: true
                        }
                    }} className="btn btn-floating pink lighten-1">
                        {props.profile.initials}
                    </NavLink>
                </li> */}
                <li style={{ height: 60 }}>
                    <LanguageSelectorComponent />
                </li>

            </ul>

        </span>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        signOut: () => dispatch(signOut())
    }
}

export default connect(null, mapDispatchToProps)(SignedInLinks)
